<div class="row">
  <form [formGroup]="form">
    <div class="text-center mt-3">
      <div *ngIf="showCoproOption" class="mb-2">
        <div>Le bien est-il en copropriété ?</div>
        <mat-radio-group [formControl]="form_isInCondo">
          <mat-radio-button [value]="true">Oui</mat-radio-button>
          <mat-radio-button [value]="false">Non</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
    <div class="text-center mt-3">
      <div class="mb-2">
        <div>Le bien est-il à vendre ?</div>
        <mat-radio-group [formControl]="form_isToSale">
          <mat-radio-button [value]="true">Oui</mat-radio-button>
          <mat-radio-button [value]="false">Non</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="row">
        <app-input
          type="number"
          label="price"
          [formControl]="form_price"
          suffixIcon="euro"
        ></app-input>
        <app-input
          [label]="'dateOnSale'"
          type="date"
          [formControl]="form_dateOnSale"
        ></app-input>
      </div>
      <div class="row">
        <app-input
          [label]="'promotionalText'"
          type="text"
          [isTextarea]="true"
          [formControl]="form_promotionalText"
          [size]="12"
        ></app-input>
      </div>
    </div>
  </form>
</div>
